module.exports = "https://static.zego.com/_next/static/images/blog-category-b2c-a5e577c8f16124dd586f0c03cc7d3324.jpg";